import { Box, Flex } from '@chakra-ui/react';

import { Shimmer } from 'components/Shimmer';
import { radius } from 'styles/revampTokens';

const ROW_COUNT = 7;

export const DimensionsSidebarSkeleton = () => (
  <Flex flexDirection='column' gap='4px' px='12px' py='8px'>
    {Array.from({ length: ROW_COUNT }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Flex key={index} alignItems='center' gap='8px' height='40px' px='8px' flexShrink={0}>
        <Shimmer width='14px' height='14px' borderRadius={radius.control} flexShrink={0} />
        <Shimmer flex='1' height='10px' borderRadius='4px' maxW='70%' />
      </Flex>
    ))}
  </Flex>
);

const PROPERTY_FIELD_COUNT = 3;

/** Shown inside the Properties panel while a newly selected dimension's
 *  properties load, so the panel stays open across dimension switches. */
export const DimensionsPropertiesSkeleton = () => (
  <Flex flexDir='column' flex='1' minH={0}>
    <Box px='12px' pt='12px' pb='12px' borderBottom='1px solid #D1D6DD' flexShrink={0}>
      <Flex bg='#F1F1F4' borderRadius={radius.control} p='4px' gap='2px'>
        {Array.from({ length: PROPERTY_FIELD_COUNT }).map((_, index) => (
          <Shimmer
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            flex='1'
            height='30px'
            borderRadius={radius.control}
          />
        ))}
      </Flex>
    </Box>
    <Flex flexDir='column' gap='12px' px='12px' py='12px'>
      {Array.from({ length: PROPERTY_FIELD_COUNT }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={index}>
          <Shimmer width='64px' height='9px' borderRadius='4px' mb='8px' />
          <Shimmer width='100%' height='36px' borderRadius={radius.control} />
        </Box>
      ))}
    </Flex>
  </Flex>
);

/** Matches the Settings panel's two toggle rows + one grouped-by field. */
export const DimensionsSettingsSkeleton = () => (
  <Flex flexDir='column' gap='12px' px='12px' py='12px'>
    {Array.from({ length: 2 }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Shimmer key={index} width='100%' height='40px' borderRadius={radius.control} />
    ))}
    <Box>
      <Shimmer width='64px' height='9px' borderRadius='4px' mb='8px' />
      <Shimmer width='100%' height='36px' borderRadius={radius.control} />
    </Box>
  </Flex>
);

const TABLE_COLUMN_WIDTHS = ['140px', '90px', '90px', '70px', '70px', '90px'];
const TABLE_ROW_COUNT = 9;

export const DimensionsTableSkeleton = () => (
  <Box border='1px solid #D1D6DD' borderRadius={radius.surface} overflow='hidden'>
    <Flex
      bg='#F5F0FF'
      borderBottom='1px solid #D1D6DD'
      height='38px'
      alignItems='center'
      px='16px'
      gap='24px'
    >
      {TABLE_COLUMN_WIDTHS.map((width, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Shimmer
          key={index}
          width={width}
          height='10px'
          borderRadius={radius.control}
          flexShrink={0}
        />
      ))}
    </Flex>
    {Array.from({ length: TABLE_ROW_COUNT }).map((_, rowIndex) => (
      <Flex
        // eslint-disable-next-line react/no-array-index-key
        key={rowIndex}
        height='34px'
        alignItems='center'
        px='16px'
        gap='24px'
        borderBottom='1px solid #D1D6DD'
      >
        {TABLE_COLUMN_WIDTHS.map((width, columnIndex) => (
          <Shimmer
            // eslint-disable-next-line react/no-array-index-key
            key={columnIndex}
            width={width}
            height='9px'
            borderRadius={radius.control}
            flexShrink={0}
          />
        ))}
      </Flex>
    ))}
  </Box>
);
